import ChsAddress from 'domain/types/ChsAddress';

function hasMailingAddress(address: ChsAddress | null) {
  if (!address) {
    return false;
  }
  if (
    !address.houseNumber ||
    !address.streetName ||
    !address.city ||
    !address.state ||
    !address.zipCode
  ) {
    return false;
  }

  if (
    address.singleFamilyHome !== 'Y' &&
    (!address.unitType || !address.unitNumber)
  ) {
    return false;
  }

  return true;
}

export default hasMailingAddress;
